export const DEFAULT_PAGE = 0;
export const DEFAULT_MAX_SIZE = 3;

export interface PageItem {
  label: string;
  page: number;
}

export function buildPageItems(length: number, shift = 0): PageItem[] {
  return Array.from(new Array(length), (x, i) => {
    const item: PageItem = {
      label: `${shift + i + 1}`,
      page: shift + i,
    };
    return item;
  });
}

export function shiftPageItems(
  currentPage: number,
  pageItems: PageItem[],
  maxSize: number,
  lastPage: number,
): PageItem[] | null {
  if (currentPage === 0 || lastPage < maxSize || !pageItems) {
    return buildPageItems(maxSize);
  }
  if (currentPage > lastPage - maxSize + 1) {
    const shift = lastPage - maxSize + 1;
    return buildPageItems(maxSize, shift);
  }
  const firstPageInRow = pageItems[0]?.page;
  const lastPageInRow = pageItems[pageItems.length - 1]?.page;

  const isFirstPageInRow = currentPage === firstPageInRow;
  if (isFirstPageInRow) {
    const shift = firstPageInRow - 1;
    return buildPageItems(maxSize, shift);
  }
  const isLastPageInRow = currentPage === lastPageInRow;
  if (isLastPageInRow) {
    const shift = firstPageInRow + 1;
    return buildPageItems(maxSize, shift);
  }
  return null;
}
